export default "__VITE_ASSET__upX7So99__"